// Individual exports for testing
import { call, put, all, spawn, takeLatest } from 'redux-saga/effects';
import request from '../../utils/request';
import { TEST } from '../../utils/constants';
import { UPDATE_EASY_SPLIT_CONFIG_URL } from '../../constants/url';
import { disableLoaderAction } from './actions';
import { REQUEST_ACTIVATION } from './constants';
import { showToast } from '../Toast/actions';

export function* requestActivation({ data: { cb, data, isTryTest } }) {
  try {
    const { url, method } = UPDATE_EASY_SPLIT_CONFIG_URL;
    const options = {
      method,
      body: JSON.stringify(data),
    };

    if (isTryTest) options.envCall = TEST;

    const response = yield call(request, url, options);

    cb(response);
  } catch (err) {
    yield put(showToast(err));
  } finally {
    yield put(disableLoaderAction());
  }
}

export function* requestActivationSaga() {
  yield takeLatest(REQUEST_ACTIVATION, requestActivation);
}

// Individual exports for testing
export default function* easySplitSaga() {
  // See example in containers/HomePage/saga.js
  const sagas = [requestActivationSaga];

  yield all(
    sagas.map(saga =>
      // eslint-disable-next-line func-names
      spawn(function*() {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e);
          }
        }
      }),
    ),
  );
}
